<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Nilai Evaluasi Kinerja">
            <br>
            <common-training-header :withUser="true"/>
        </a-page-header>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :dataSource="tableData"
                rowKey="id"
                :loading="loading"
                :pagination="false"
                bordered>

                <a-table-column-group>
                    <span slot="title">Total Nilai</span>
                    <a-table-column :key="aspect.code" :title="aspect.name + ' ' + (aspect.weight*100) + '%'" v-for="aspect in this.aspects" className="column-center">
                        <template slot-scope="record">
                            <div v-if="record.scorer.presentasi_column === aspect.code">
                                <center>{{ record.scorer.total_presentasi }}</center>
                            </div>
                            <div v-if="record.scorer.evaluasi_column === aspect.code">
                                <center>{{ record.scorer.total_isi }}</center>
                            </div>
                        </template>
                    </a-table-column>
                </a-table-column-group>

                <a-table-column key="final_score" title="Nilai Akhir" width="15%" className="column-score">
                    <template slot-scope="record">
                        <center>{{ record.scorer.final_score }}</center>
                    </template>
                </a-table-column>
            </a-table>
        </a-card>
    </div>
</template>

<script>
    const columns = [
        {
            key: 'total',
            title: 'Total Nilai',
            scopedSlots: {customRender: 'total'},
            children: [
                {
                    key: 'total_presentasi',
                    title: 'Presentasi 20%',
                    align: 'center',
                    scopedSlots: {customRender: 'total_presentasi'},
                },
                {
                    key: 'total_isi',
                    title: 'Evaluasi 60%',
                    align: 'center',
                    scopedSlots: {customRender: 'total_isi'},
                },
            ]
        },
        {
            key: 'final_score',
            title: 'Nilai Akhir',
            align: 'center',
            scopedSlots: {customRender: 'final_score'}
        }
    ]

    export default {
        data() {
            return {
                columns,
                items: [],
                aspects: [],
                loading: false
            }
        },
        created() {
            this.getItems()
        },
        methods: {
            getItems(){
                let params = {
                    user_hash: this.$laravel.user.hash,
                    recap_type: 'attendant'
                }

                this.loading = true

                this.$http
                    .get(this.routeUri('api.recap.activity-score.attendants_result')+ '?' + this.$qs.stringify(params))
                    .then(response => { 
                        this.items = response.data.attendants
                        this.aspects = response.data.aspects
                    })
                    .catch(error => this.handleXhrError(error))
                    .finally(() => (this.loading = false))
            },
        },
        computed: {
            tableData(){
                if(this.items.length > 0){
                    let idx = 0
                    let collection = []
                    let scorer = {}
                    let idx2 = 0
                    let totPresentasi = 0
                    let totIsi = 0

                    this.items.forEach(function(item){
                        idx++
                        item.evaluators.forEach(function(evaluator){
                            let scoreEvaluator = item.activities[0].evaluator_score[evaluator]
                            if(Array.isArray(scoreEvaluator)){
                                idx2++
                                scoreEvaluator.forEach(function(score){
                                    if(score.scoreable.scoreable_type === 'aspect' && score.scoreable.code === 'EVA-PREV'){
                                        scorer['presentasi_'+idx2] = score.raw_score
                                        totPresentasi = parseFloat(totPresentasi) + parseFloat(score.score)
                                        scorer['presentasi_column'] = score.scoreable.code
                                    }else if(score.scoreable.scoreable_type === 'aspect' && score.scoreable.code === 'EVA-EVEV'){
                                        scorer['isi_'+idx2] = score.raw_score
                                        totIsi = parseFloat(totIsi) + parseFloat(score.score)
                                        scorer['evaluasi_column'] = score.scoreable.code
                                    }

                                })
                            }
                        })

                        let presentasi = totPresentasi / idx2
                        let isi = totIsi / idx2

                        if(isNaN(presentasi)){
                            presentasi = 0
                        }
                        if(isNaN(isi)){
                            isi = 0
                        }

                        scorer['total_presentasi'] = parseFloat(presentasi).toFixed(2)
                        scorer['total_isi'] = parseFloat(isi).toFixed(2)

                        scorer['final_score'] = parseFloat(presentasi + isi).toFixed(2)
                        collection.push({
                            id: idx,
                            scorer
                        })
                    })

                    return collection
                }

                return []
            }
        },
    }
</script>
